/*
 * General forms scripts
 */
import $ from "jquery";

$( document ).on( 'ready', function() {
// $('#revinate_contact_api_form').on( 'submit', function (e) {
//     e.preventDefault();
//     var emailval = $('input#email').val();
//     console.log(emailval);
//     if (emailval !== "") {
//         $.ajax({
//             cache: false, // no cache
//             url: '/echo/json/', // your url; on jsfiddle /echo/json/
//             type: 'POST', // request method
//             dataType: 'json', // the data type, here json. it's simple to use with php -> json_decode
//             token: form.attr('token'),
//             data: {
//                 email: emailval // here the email
//             },
//             success: function (data) {
//                 console.log(data);
//             },
//             error: function (e) {
//                 // error
//             },
//             fail: function () {
//                 // fail
//             }
//         });
//     } else {
//         return;
//     }
// });
    // if(typeof Marionette !== 'undefined') {
    //     var customDatePicker = Marionette.Object.extend( {
    //     initialize: function() {
    //         this.listenTo( Backbone.Radio.channel( 'flatpickr' ), 'init', this.modifyDatepicker );
    //     },
    //     modifyDatepicker: function( dateObject, fieldModel ) {
    //         var tomorrow = new Date();
    //         tomorrow.setDate(tomorrow.getDate() + 1);
    //         dateObject.set("minDate", tomorrow );
    //         }
    //     });
	//     new customDatePicker();
    // }

    // if(typeof Marionette !== 'undefined') {
    //     // Create a new object for custom validation of a custom field.
    //     var myCustomFieldController = Marionette.Object.extend( {
    //         initialize: function() {

    //             // On the Form Submission's field validaiton...
    //             var submitChannel = Backbone.Radio.channel( 'submit' );
    //             this.listenTo( submitChannel, 'validate:field', this.validateRequired );

    //             // on the Field's model value change...
    //             var fieldsChannel = Backbone.Radio.channel( 'fields' );
    //             this.listenTo( fieldsChannel, 'change:modelValue', this.validateRequired );
    //         },

    //         validateRequired: function( model ) {

    //             // Only validate a specific fields type.
    //             if( 'custom' != model.get( 'type' ) ) return;

    //             // Only validate if the field is marked as required?
    //             if( 0 == model.get( 'required' ) ) return;

    //             // Check if Model has a value
    //             if( model.get( 'value' ) ) {
    //                 // Remove Error from Model
    //                 Backbone.Radio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'custom-field-error' );
    //             } else {
    //                 // Add Error to Model
    //                 Backbone.Radio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'custom-field-error', 'This is an error message' );
    //             }
    //         }
    //     });
    //     // Instantiate our custom field's controller, defined above.
    //     new myCustomFieldController();
    // }
}).on('gform_page_loaded', function(event, form_id, current_page){
    // code to be trigger when next/previous page is loaded
    console.log( 'event ' + event );
    console.log( 'form id ' + form_id );
    console.log( 'current page ' + current_page );
});